import { render, staticRenderFns } from "./DraftList.vue?vue&type=template&id=d3982462&scoped=true&"
import script from "./DraftList.vue?vue&type=script&lang=js&"
export * from "./DraftList.vue?vue&type=script&lang=js&"
import style0 from "./DraftList.vue?vue&type=style&index=0&id=d3982462&prod&lang=scss&scoped=true&"
import style1 from "./DraftList.vue?vue&type=style&index=1&id=d3982462&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3982462",
  null
  
)

export default component.exports